// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/f/Projects/mansion/guidelines/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-color-js": () => import("/Users/f/Projects/mansion/guidelines/src/pages/color.js" /* webpackChunkName: "component---src-pages-color-js" */),
  "component---src-pages-index-js": () => import("/Users/f/Projects/mansion/guidelines/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-logo-js": () => import("/Users/f/Projects/mansion/guidelines/src/pages/logo.js" /* webpackChunkName: "component---src-pages-logo-js" */),
  "component---src-pages-typography-js": () => import("/Users/f/Projects/mansion/guidelines/src/pages/typography.js" /* webpackChunkName: "component---src-pages-typography-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/f/Projects/mansion/guidelines/.cache/data.json")

